import PropTypes from 'prop-types';
import React, { useEffect } from 'react';
import loginAPI from '../../utils/ajax';
import swal from 'sweetalert';
import { useAuth } from '../../context/AuthContext';

const SignIn = (e) => {
  const { login } = useAuth();
  const params = new URLSearchParams(window.location.search);

  useEffect(async () => {
    const authCode = params.get('auth_code');
    const clientCode = params.get('client_id');

    const [response, error] = await loginAPI(
      'POST',
      'auth/angelbroking/user/v1/oauth/token',
      {},
      {
        clientcode: clientCode,
        code: authCode,
      },
      {}
    );
    if (response.status === true) {
      login(response.data.jwtToken);
    } else {
      swal({
        text: 'error',
        icon: 'warning',
      });
    }

    response();
  }, [params]);
  return (
    <div>
      <h2>Logging in...</h2>
    </div>
  );
};
export default SignIn;

SignIn.propTypes = {
  history: PropTypes.any.isRequired,
};
